import * as lib from 'Root/lib/lib.js'
import ajaxMixins from 'Root/vue/mixins/ajaxMixins'
import Loader from 'Root/vue/components/Loader.vue'
import PublicStatisticsResults from 'Root/vue/components/PublicStatistics/PublicStatisticsResults.vue'
import ResponseError from 'Root/vue/components/ResponseError.vue'

export default {
    components: {
        Loader,
        'public-statistics-results': PublicStatisticsResults,
        'response-error': ResponseError,
    },

    mixins: [ajaxMixins],

    data() {
        return {
            loading: false,
            hasError: false,
            errorMessages: '',

            results: null,
        }
    },

    mounted() {
        this.getResults()
    },

    methods: {
        getResults() {
            this.ajax(this.appData.configuration.dataEndpoint, null, this.storeResults, this.showError)
        },

        storeResults(data) {
            this.results = data.results
        },

        showError() {
            this.results = null
        },

        scrollToResults() {
            this.$nextTick(() => {
                lib.moveWindowToObj(jQuery(this.$el).find('.s-statistics__results__head'), -50)
            })
        },
    },
}
